module.exports = "/_next/static/images/photoRuslanBaxanean-ff2f1a98d2c6990bfc81b2f927feefec.webp";